import { render, staticRenderFns } from "./datos.vue?vue&type=template&id=6584bd14&scoped=true&"
import script from "./datos.vue?vue&type=script&lang=js&"
export * from "./datos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6584bd14",
  null
  
)

export default component.exports